import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var AuthCounselorsGuard = /** @class */ (function () {
    function AuthCounselorsGuard(routes) {
        this.routes = routes;
    }
    AuthCounselorsGuard.prototype.canActivate = function (next, state) {
        if (localStorage.getItem('user_type_id') == '3') {
            return true;
        }
        else {
            this.routes.navigate(['/accueil']);
            return false;
        }
    };
    AuthCounselorsGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthCounselorsGuard_Factory() { return new AuthCounselorsGuard(i0.inject(i1.Router)); }, token: AuthCounselorsGuard, providedIn: "root" });
    return AuthCounselorsGuard;
}());
export { AuthCounselorsGuard };
